import $ from 'jquery';
import enquire from 'enquire.js';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import isInViewport from '../modules/isInViewport.js';
import throttle from '../modules/throttle.js';
import * as focusTrap from 'focus-trap';
import userPrefersReducedMotion from '../modules/userPrefersReducedMotion';
import { enableLinksInsideActiveSlides, disableLinksInInactiveSlides } from '../modules/flickityAccessibility.js';

Flickity.setJQuery($);
jQueryBridget('flickity', Flickity, $);

const HomeRoute = () => {

  //
  //   Slideshows
  //
  //////////////////////////////////////////////////////////////////////

  //   Features
  //--------------------------------------------------------------------
  const $featureSlideshowBtns = $('.js-slider-btn');
  const $featureSlideshow = $('.js-feature-slideshow');
  const featuredSlideSelector = '.js-feature-slideshow-slide';
  const isSelectedClass = 'is-selected';
  const visuallyHiddenSelector = ('.h-hide-visually');

  const getVisuallyHiddenSpan = (btn) => {
    return $(btn).find(visuallyHiddenSelector);
  };

  const clearVisuallyHiddenBtnText = () => {
    $featureSlideshowBtns.each((i, button) => {
      const $srOnlySpan = getVisuallyHiddenSpan(button);
      if ($srOnlySpan.length) {
        $srOnlySpan.text('');
      }
    });
  };

  const markButtonAsActive = (btn) => {
    const $srOnlySpan = getVisuallyHiddenSpan(btn);
    if ($srOnlySpan) {
      $srOnlySpan.text(' (Current Slide)');
    }
  };

  const getButtonBySlideIndex = (index) => {
    return $featureSlideshowBtns.filter(`[data-connects-with="${index}"]`);
  };


  const activateSlideByButton = (btn) => {
    const connectsWith = $(btn).attr('data-connects-with');
    $featureSlideshow.flickity().flickity('select', connectsWith);
  };

  // init Flickity
  $featureSlideshow.flickity({
    cellSelector: featuredSlideSelector,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    draggable: true,
    selectedAttraction: 0.08,
    friction: 0.5,
    imagesLoaded: true,
    on: {
      change: function(index) {
        $featureSlideshowBtns.removeClass(isSelectedClass);
        $featureSlideshowBtns.filter(function() {
          return $(this).attr('data-connects-with') == index;
        }).addClass(isSelectedClass);

        // Reset visually-hidden text for all buttons
        clearVisuallyHiddenBtnText();

        // Add visually-hidden text to the active button
        const $activeButton = getButtonBySlideIndex(index);
        if ($activeButton.length) {
          markButtonAsActive($activeButton);
        }

        disableLinksInInactiveSlides(this);
        enableLinksInsideActiveSlides(this);
      },
      ready: function() {
        disableLinksInInactiveSlides(this);
        enableLinksInsideActiveSlides(this);
        // Mark first slide button as active
        markButtonAsActive($featureSlideshowBtns.first());
      }
    }
  });

  // Connecting to Buttons
  $featureSlideshowBtns.bind('click', function() {
    activateSlideByButton($(this));
  });

  $featureSlideshowBtns.bind('keydown', function(event) {
    const shouldActivate = event.key === 'Enter' || event.key === ' ';

    if (!shouldActivate) return;

    event.preventDefault();
    activateSlideByButton($(this));
  });

  // Select slides when clicked on
  $featureSlideshow.on('staticClick.flickity', function(ev) {
    let $slide = $(ev.originalEvent.srcElement);
    if (!$slide.is(featuredSlideSelector)) {
      $slide = $slide.closest(featuredSlideSelector);
      if (!$slide.length) {
        return;
      }
    }
    $featureSlideshow.flickity('select', $slide.attr('data-index'));
  });


  //   In the Field
  //--------------------------------------------------------------------
  const initGallery = ($mockupSlideshow) => {
    const mockupSlideSelector = '.js-mockup-gallery-slide';

    // init Flickity
    $mockupSlideshow.flickity({
      cellSelector: mockupSlideSelector,
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      draggable: true,
      selectedAttraction: 0.08,
      imagesLoaded: true,
      friction: 0.5
    });
  
    // Select slides when clicked on
    $mockupSlideshow.on('staticClick.flickity', function(ev) {
      let $slide = $(ev.originalEvent.srcElement);
      if (!$slide.is(mockupSlideSelector)) {
        $slide = $slide.closest(mockupSlideSelector);
        if (!$slide.length) {
          return;
        }
      }
      $mockupSlideshow.flickity('select', $slide.attr('data-index'));
    });
  }

  const $mockupSlideshow = $('.js-mockup-gallery');
  initGallery($mockupSlideshow);
  

  //   Feature Overview
  //--------------------------------------------------------------------
  const $featureOverview = $('.js-feature-overview');
  const slideshowBreakpoint = 'screen and (max-width: 879px)';

  $featureOverview.flickity({
    cellSelector: '.js-feature-overview-item',
    wrapAround: true,
    pageDots: true,
    prevNextButtons: false,
    draggable: true,
    watchCSS: true,
    selectedAttraction: 0.08,
    friction: 0.5
  });

};

export default HomeRoute;
